/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Close } from '../private/icons/Close';
import { ArrowBack } from '../private/icons/ArrowBack';
import { IconButton } from '../button/IconButton';

const DrawerAction = React.forwardRef((props, ref) => {

  const {
    leftMargin,
    ...rest
  } = props;

  const classes = classNames(
    'sui-flex sui-items-start sui-items-center sui-pl-0 sui-pb-0 sui-pr-4 sui--m-2',
    {
      'sui-ml-auto': leftMargin
    }
  );

  return (
    <div
      className={classes}
      ref={ref}
      {...rest}
    />
  );
});

const DrawerHeaderRoot = React.forwardRef((props, ref) => {

  const classes = 'sui-sticky sui-top-0 sui-bg-primary sui-flex sui-w-full sui-text-left sui-flex-col sui-gap-1 sui-py-2 sui-pl-4';

  return (
    <div
      className={classes}
      ref={ref}
      {...props}
    />
  );
});

const DrawerHeader = (props) => {

  const {
    children,
    endAction,
    onBack,
    onClose,
    startAction
  } = props;

  return (
    <DrawerHeaderRoot>
      <div className="sui-flex">
        {startAction != null ? (
          <DrawerAction>
            {startAction}
          </DrawerAction>
        ) : null}
        {startAction == null && onBack ? (
          <div className="sui-flex sui-items-center">
            <IconButton
              aria-label="drawer-close"
              onClick={onBack}
              icon={ArrowBack}
            />
          </div>
        ) : null}
        {children}
        {endAction != null ? (
          <DrawerAction>
            {endAction}
          </DrawerAction>
        ) : null}
        {endAction == null && onClose ? (
          <DrawerAction leftMargin={!onBack}>
            <IconButton
              aria-label="drawer-close"
              onClick={onClose}
              icon={Close}
            />
          </DrawerAction>
        ) : null}
      </div>
    </DrawerHeaderRoot>
  );
};

DrawerHeader.displayName = 'DrawerHeader';

DrawerHeader.propTypes = {
  /**
   * DrawerHeader children, usually DrawerTitle.
   */
  children: PropTypes.node,
  /**
   * Function to handle a close event for drawer.
   */
  onClose: PropTypes.func,
  /**
   * Function to handle the back event for nested drawer.
   */
  onBack: PropTypes.func,
  /**
   * Icon that goes at the end of drawer header.
   */
  endAction: PropTypes.node,
  /**
   * Icon that goes at the beginning of drawer header.
   */
  startAction: PropTypes.node
};

DrawerHeader.defaultProps = {
};

export { DrawerHeader };